import type { FaireProductEntity } from "../../entity_types/product";

export const p_qkdeevrq5d: FaireProductEntity = {
  token: "p_qkdeevrq5d",
  type: "product",
  name: "Cherry Sequin Patch Baseball Hat - Hair Accessories - Spring",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/a1d0f1c2e5d190fb6e35d9b9303ee58c7803e90ea50565816e6a394110568e92.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4b1d39dedcc5ea06a724e73de85afc25957e3ea03f6ba9976272b26d96b8a8b.jpeg",
    "https://cdn.faire.com/fastly/6567b331d55ed1d6527e9bbc89895b4e82f6100afa3989e868444dc6f9191d93.jpeg",
    "https://cdn.faire.com/fastly/258511caf9a2971f09a78f946fcb4011c534c6d59ac56c8d742ed7d75b311d98.jpeg",
    "https://cdn.faire.com/fastly/197fd24260dbeaa8e1f7837519e23f3c45836af3cdf8c8a5c98897c72e7eba12.jpeg",
    "https://cdn.faire.com/fastly/e09fc1f7315d5b051662cf079087f0712d92de6328ccaa16eb70e6ef5d02091a.jpeg",
  ],
  priceDollars: 16,
  description:
    "This adorable cap adds the sweetest pop with its dainty bow and sparkling sequin cherry detail, perfect for sunny days and extra-cute outfits.\n\nFeatures:\n * Hat Color: White \n * Patch Color: Red, Pink and Green \n * Material: 100% cotton bio-washed chino twill \n * Features: Unstructured, six-panel, low-profile; pre-curved visor; self-fabric tri-glide buckle closure \n * Size: Recommended for ages 4+ \n\nEach hat is hand-pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:12.443Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
